import { Component, Input } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml
} from "@angular/platform-browser";

import { CoreMenuItem } from '@core/types';
import { SvgTemplateService } from "app/common/services/svg-template.service";

@Component({
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;
  svgContent!: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    private svgTemplateService: SvgTemplateService
  ) {}

  ngOnInit() {
    if(!this.item.isFeatherIcon){
      this.svgContent = this.sanitizer.bypassSecurityTrustHtml(
        this.svgTemplateService.getTemplate(this.item.icon)
      );
    }    
  }
}
